// extracted by mini-css-extract-plugin
export var dividerLine = "_6s-3";
export var itemImage = "_6s-9";
export var lightDivider = "_6s-4";
export var modalContent = "_6s-5";
export var modalContentCompact = "_6s-6";
export var productCard = "_6s-a";
export var productImage = "_6s-b";
export var productImageCompact = "_6s-7";
export var productImagePlaceholder = "_6s-c";
export var productImagePlaceholderCompact = "_6s-8";
export var progressBarBackground = "_6s-1";
export var progressBarContainer = "_6s-0";
export var progressBarFill = "_6s-2";